const pluralize = (word, count = 0) => (count === 1 ? word : `${word}s`);

export default pluralize;
